// firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBm39RkgGQVZlAs3uL1jJib_JzSvB1TTlU",
  authDomain: "gelogical-project.firebaseapp.com",
  projectId: "gelogical-project",
  storageBucket: "gelogical-project.firebasestorage.app",
  messagingSenderId: "406622239594",
  appId: "1:406622239594:web:5d3a10d3c3659effbe0313",
  measurementId: "G-BSN9CRW1HE",
};

// Initialize Firebase and Firestore
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
